"use client";

import { c as _c } from "react/compiler-runtime";
import { EditorContent, useEditor } from "@tiptap/react";
import { BubbleMenu, FloatingMenu } from "@tiptap/react/menus";
import { useRef } from "react";
import { cn } from "@/lib/utils";
import { BubbleMenuBar, FloatingMenuBar } from "@/ui/admin/tiptap-bubble-menu";
import { defaultTiptapExtensions } from "./tiptap-extensions";
export function TiptapEditor(t0) {
  const $ = _c(22);
  const {
    toolbarOverrides,
    content,
    onChange,
    className
  } = t0;
  const t1 = content || "";
  let t2;
  let t3;
  if ($[0] !== onChange) {
    t2 = t4 => {
      const {
        editor
      } = t4;
      onChange(editor.getJSON());
    };
    t3 = t5 => {
      const {
        editor: editor_0
      } = t5;
      onChange(editor_0.getJSON());
    };
    $[0] = onChange;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      enableContentCheck: false,
      immediatelyRender: false,
      extensions: defaultTiptapExtensions,
      content: t1,
      onUpdate: t2,
      onBlur: t3
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const editor_1 = useEditor(t4);
  const x = useRef(null);
  let t5;
  if ($[7] !== className) {
    t5 = cn("tiptap-editor", className);
    $[7] = className;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== editor_1) {
    t6 = <EditorContent editor={editor_1} className="min-h-[28px] [&>[contenteditable]>*]:min-h-[28px] prose prose-stone prose-p:my-0 prose-h2:my-0 prose-h3:my-0 prose-h4:my-0 dark:prose-invert max-w-none focus-visible:outline-none" />;
    $[9] = editor_1;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== editor_1 || $[12] !== toolbarOverrides) {
    t7 = editor_1 && <BubbleMenu editor={editor_1} options={{
      placement: "top"
    }} ref={x} shouldShow={_temp} className="bubble-menu"><BubbleMenuBar editor={editor_1} toolbarOverrides={toolbarOverrides} /></BubbleMenu>;
    $[11] = editor_1;
    $[12] = toolbarOverrides;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== editor_1 || $[15] !== toolbarOverrides) {
    t8 = editor_1 && <FloatingMenu editor={editor_1} options={{
      placement: "bottom-start"
    }}><FloatingMenuBar editor={editor_1} toolbarOverrides={toolbarOverrides} /></FloatingMenu>;
    $[14] = editor_1;
    $[15] = toolbarOverrides;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = <div className={t5}>{t6}{t7}{t8}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}
function _temp(t0) {
  const {
    view,
    state
  } = t0;
  const {
    selection
  } = state;
  const {
    empty
  } = selection;
  if (empty) {
    return false;
  }
  view.hasFocus();
  document.activeElement?.closest(".bubble-menu");
  return true;
}